import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["className", "dataHook", "children", "onClick", "underline", "prefixIcon", "suffixIcon", "id", "disabled", "size", "light", "ellipsis", "skin", "weight", "disableClick"];
import React from 'react';
import clsx from 'clsx';
import { Text } from '../Text/Text';
import s from './TextButton.scss';
export const TextButton = _ref => {
  let className = _ref.className,
    dataHook = _ref.dataHook,
    children = _ref.children,
    onClick = _ref.onClick,
    underline = _ref.underline,
    prefixIcon = _ref.prefixIcon,
    suffixIcon = _ref.suffixIcon,
    id = _ref.id,
    disabled = _ref.disabled,
    size = _ref.size,
    light = _ref.light,
    ellipsis = _ref.ellipsis,
    _ref$skin = _ref.skin,
    skin = _ref$skin === void 0 ? 'standard' : _ref$skin,
    weight = _ref.weight,
    disableClick = _ref.disableClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    "data-hook": dataHook,
    id: id,
    disabled: disabled || disableClick,
    className: clsx(s.textButton, {
      [s.disabled]: disabled,
      [s.disableClick]: disableClick,
      [s.standard]: skin === 'standard',
      [s.shadow]: skin === 'shadow'
    }, className),
    onClick: onClick
  }, props), prefixIcon || null, /*#__PURE__*/React.createElement(Text, {
    className: clsx(s.text, {
      [s.underline]: underline === 'always',
      [s.underlineOnHover]: underline === 'onHover'
    }),
    size: size,
    light: light,
    weight: weight,
    ellipsis: ellipsis
  }, children), suffixIcon || null);
};
//# sourceMappingURL=TextButton.js.map